import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  SalesReturnService,
} from "../../../services/index";
import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./salesReturn.html",
})
export class SalesInvoiceReturn implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_id: "",
    finYrVal: "",
    credit_id: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "creditno",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  creditList = [];
  partyList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("credit") credit;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  returnList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private salesservice: SalesReturnService,
    private combo: Combo2Service,
    private comboservice: ComboService,
    private modalService: BsModalService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.finyearCombo();
    this.getPartyList();
    // this.getReturnList();
    // this.getCreditList();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Credit. No",
        prop: "creditno",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Ret Date",
        prop: "ret_date",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Party",
        prop: "party_name",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 300,
        maxWidth: 300,
        width: 300,
      },
      {
        name: "F.Tot",
        prop: "Ftot",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "H.Tot",
        prop: "Htot",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "Tot.Pcs",
        prop: "Tot",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
        cellClass: "text-center",
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      // {
      //   name: "Details",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.detailsTemplate,
      // }
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getReturnList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  clearFilter(): void {
    // this.filter.finYrVal= "";
    this.filter.credit_id = "";
    this.filter.party_id = "";
    this.applyFilter();
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.getReturnList();
  }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
        that.finyearCtrl.setValue(res.data[0].fin_id);
       that.filter.finYrVal = res.data[0].finyear;
       that.getReturnList();
    });
  }

  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  displayCredit(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Credit") {
      list = this.creditList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { creditid: id });
      return fitem["creditno"];
    }
    return "";
  }

  getCreditList(year, id) {
    let params = {
      finYrVal: year,
      party_id: id,
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesInvoiceReturnNo(params).then((res: any) => {
      this.creditList = res;
    });
  }

  bsModalRef: BsModalRef;
  print(row: any) {
    let params = {
      printType: "creditnote",
      creditid: row.creditid,
      party_id: row.party_id,
    };
    this.salesservice.print(params).then((res: any) => {
      this.printData = res;
      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printreturn = this.printData;
    });
  }
  printDetails(row: any) {
    let params = {
      printType: "creditnotedetails",
      creditid: row.creditid,
      party_id: row.party_id,
    };
    this.salesservice.print(params).then((res: any) => {
      this.printData = res;
      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printreturndet = this.printData;
    });
  }

  addEditSalesReturn(mode: string, row: any): void {
    this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getReturnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD SALES INVOICE RETURN",
          title: "ADD SALES INVOICE RETURN",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          list: this.returnList,
          name: "ADD SALES INVOICE RETURN",
        },
      };
    } else if (mode == "Edit"){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT SALES INVOICE RETURN",
          title: "EDIT SALES INVOICE RETURN",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          list: this.returnList,
          name: "EDIT SALES INVOICE RETURN",
        },
      };
    }else if (mode == "View"){
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW SALES INVOICE RETURN",
          title: "VIEW SALES INVOICE RETURN",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          list: this.returnList,
          name: "VIEW SALES INVOICE RETURN",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getReturnList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      finYrVal: this.filter.finYrVal,
      party_id: this.filter.party_id,
      creditid: this.filter.credit_id,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .getSalesInvRtnList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.returnList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          that.returnList[i].ret_date = that.datePipe.transform(
            res.data[i].retdate,
            "dd-MM-yyyy"
          );
        }
      });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesReturn/salesReturn.ts